<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import { useTableStore } from '@/stores/tableStore.ts'
import { computed, onMounted, watch } from 'vue'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const tableStore = useTableStore()

const props = defineProps({
  tableStoreName: {
    type: String,
    required: true
  }
});

// Helper to access the dynamic table state with proper typing
const tableState = computed(() => {
  return (tableStore as unknown as Record<string, { page: number; rowsPerPage: number; totalFilteredRows: number }>)[props.tableStoreName]
})

// Method to handle page change
const handlePageChange = (newPage: number) => {
  const totalPages = Math.ceil(tableState.value.totalFilteredRows / tableState.value.rowsPerPage);
  if (newPage >= 0 && newPage <= totalPages) {
    tableState.value.page = newPage;
  }
};

// watch if the totalFilteredRows changes and we are on a page that does not exist anymore
watch(() => tableState.value.totalFilteredRows, (newVal) => {
  const totalPages = Math.ceil(newVal / tableState.value.rowsPerPage);
  if (tableState.value.page > (totalPages-1)) {
    tableState.value.page = 0;
  }
});

onMounted(() => {
  // If the totalFilteredRows is 0, reset the page to 0
  const totalPages = Math.ceil(tableState.value.totalFilteredRows / tableState.value.rowsPerPage);
  if (tableState.value.page > (totalPages-1)) {
    tableState.value.page = 0;
  }
});

</script>

<template>
  <div class="flex justify-between px-2">
    <ActionButton @click="handlePageChange(tableState.page - 1)" :disabled="tableState.page === 0">&lt;&lt;</ActionButton>
    <div class="mx-2 self-center text-subtext">{{ t('common.pagination.pageOf', { current: tableState.page + 1, total: Math.ceil(tableState.totalFilteredRows / tableState.rowsPerPage) }) }}</div>
    <ActionButton @click="handlePageChange(tableState.page + 1)" :disabled="(tableState.page + 1) >= Math.ceil(tableState.totalFilteredRows / tableState.rowsPerPage)" :end-margin="false">&gt;&gt;</ActionButton>
  </div>
</template>

<style scoped lang="scss">

button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>
